<template>
    <div class="px-3 py-2">
        <v-form
            ref="form"
            lazy-validation
        >
        <b-sidebar id="add_offer_expenses" aria-labelledby="sidebar-no-header-title" width="900px" no-header backdrop style="direction:ltr" right title="اضافة عميل" shadow >
        <template #default="{ hide }">
            <div class="m-1 text-start" style="direction:rtl">
                <div style="width:130px;margin-right:10px;background:#000;color:#FFF;border-radius:5px" class="btn-primary btn-sm text-center">
                <span>التكاليف التشغيلية</span>
                </div>
                <div @click="hide" id="hideAddExp" style="width:100px;text-align:center;float:left;margin-left:5px;margin-top:-25px;cursor:pointer" class="btn-danger btn-sm">
                <span>{{lang.close}}</span>
            </div>
        </div>
            <v-divider></v-divider>
        <div class="px-3 py-2" style="direction:rtl">
            <v-row>
                <v-col cols="12" md="12" sm="12">
                    <b-table-simple>
                        <thead>
                            <tr>
                                <th v-for="(item,index) in headers" :key="index"
                                    :class="item.class + ``" :style="item.style"
                                >{{item.text}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in tbrows" :key="index">
                                <td class="text-center p-1">{{ item.description }}</td>
                                <td class="text-center p-1">{{ item.qty }}</td>
                                <td class="text-center p-1">{{ item.price }}</td>
                                <td class="text-center p-1">{{ item.total }}</td>
                                <td class="text-center p-1">{{ item.vat }}</td>
                                <td class="text-center p-1">{{ item.ftotal }}</td>
                                <td class="text-center p-1">
                                    <b-button type="button" variant="danger" style="width:65px;border:none !important;background:red" @click="removeItem(index)">{{$parent.lang.delete}}</b-button>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th>
                                    <b-form-input class="inborder" v-model="newrow.description" />
                                </th>
                                <th>
                                    <b-form-input class="inborder" v-model="newrow.qty" @change="calcNew()" />
                                </th>
                                <th>
                                    <b-form-input class="inborder" v-model="newrow.price" @change="calcNew()" />
                                </th>
                                <th>
                                    <b-form-input class="inborder" v-model="newrow.total" readonly />
                                </th>
                                <th>
                                    <b-form-input class="inborder" v-model="newrow.vat" readonly />
                                </th>
                                <th>
                                    <b-form-input class="inborder" v-model="newrow.ftotal" readonly />
                                </th>
                                <th>
                                    <b-button type="button" variant="danger" style="width:65px;border:none !important;background:blue" @click="addItem()">{{$parent.lang.add}}</b-button>
                                </th>
                            </tr>
                        </tfoot>
                    </b-table-simple>
                </v-col>
            </v-row>
        </div>
        </template>
        <template #footer="" class="shadow">
            <div class="d-flex text-light align-items-center px-3 py-2">
                <b-button type="button" @click="addCustomer();" variant="success" class="ma-2" style="width:100px;">
                    {{lang.add}}
                </b-button>
            </div>
      </template>
        </b-sidebar>
        </v-form>
        
      </div>
</template>


<script>
import axios from 'axios';
import {SnotifyPosition} from 'vue-snotify';
export default{
    data(){
        return{
            campaign: {
                id: 0,
                city: '',
                campaign_title: '',
                campaign_start: '',
                campaign_price: '',
                campaign_end: '',
                campaign_area: 1,
                vehicle_type: '',
                car_year: '',
                campaign_target: '',
                campaign_branches: [0],
                status: 1,
            },
            tbrows: [],
            newrow: {
                description: '',
                qty: 1,
                price: '',
                total: '',
                vat: '',
                ftotal: ''
            },
            serviceList: [],
            branchies: [],
        }
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        headers: function(){
            return [
                { text: "الوصف", value: "city", class:' text-center pb-1 backBlack', style: '' },
                { text: "الكمية", value: "city", class:' text-center pb-1 backBlack', style: 'width:80px;' },
                { text: "السعر", value: "city", class:' text-center pb-1 backBlack', style: 'width:80px;' },
                { text: "الاجمالي", value: "city", class:' text-center pb-1 backBlack', style: 'width:80px;' },
                { text: "الضريبة", value: "city", class:' text-center pb-1 backBlack', style: 'width:80px;' },
                { text: "الاجمالي بعد الضريبة", value: "city", class:' text-center pb-1 backBlack', style: 'width:120px;' },
                { text: "الاجراء", value: "city", class:' text-center pb-1 blackBack', style: 'width:80px;' },
            ]
        },
    },
    created(){
        // this.getBranches();
        // this.getStaticid('inDustrial');
        // this.getStaticid('customerSource');
    },
    methods: {
        removeItem(index) {
            this.tbrows.splice(index,1)
        },
        addItem() {
            this.tbrows.push(this.newrow)
            this.newrow = {
                description: '',
                qty: 1,
                price: '',
                total: '',
                vat: '',
                ftotal: ''
            }
        },
        addCustomer(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type", "addOfferExp");
            post.append("auth", this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("lang", this.$cookies.get(this.$store.state.LangCooki));
            post.append("data[offer]", JSON.stringify(this.tbrows));
            post.append("data[id]", this.campaign.id);
            axios.post(this.$store.state.SAMCOTEC.r_path, post).then((response) => {
                this.$parent.getOffers(this.campaign.id);
                document.getElementById('hideAddExp').click();
            });
        },
        addIt(id){
            // console.log(this.serviceList);
            if(this.campaign.services.includes(id)){
                const x = this.services.indexOf(id)
                this.campaign.services.splice(x,1)
            }else{
                this.campaign.services.push(id);
            }
        },
        resetAllValues(){
            this.campaign = {
                id: 0,
                city: '',
                campaign_title: '',
                campaign_start: '',
                campaign_price: '',
                campaign_end: '',
                campaign_area: 1,
                vehicle_type: '',
                car_year: '',
                campaign_target: '',
                campaign_branches: [0],
            }
            this.tbrows = []
            this.newrow = {
                description: '',
                qty: 1,
                price: '',
                total: '',
                vat: '',
                ftotal: ''
            }
        },
        calcNew(){
            const t = this.$calcVat(parseFloat(this.newrow.qty) * parseFloat(this.newrow.price),2);
            this.newrow.total = t.tot
            this.newrow.vat = t.vat
            this.newrow.ftotal = t.ftot
        },
        getItem(id){
            this.getOffers(id)
        },
        getOffers(id){
            let cook = this.$cookies.get(this.$store.state.COOKIEPhase);
            const path = this.$router.currentRoute.path;
            let post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','getOffer');
            post.append('auth',cook);
            post.append('lang',this.$cookies.get(this.$store.state.LangCooki))
            post.append("data[id]",id)
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then((response) => {
                if(response && response.data && response.data.results && response.data.results.data){
                    this.campaign = response.data.results.data[0]
                }
            })
        },
        getBranches(id){
            let cook = this.$cookies.get(this.$store.state.COOKIEPhase);
            const path = this.$router.currentRoute.path;
            let post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','getBranchies');
            post.append('auth',cook);
            post.append('lang',this.$cookies.get(this.$store.state.LangCooki))
            post.append("data[id]",id)
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then((response) => {
                if(response && response.data && response.data.results && response.data.results.data){
                    this.branchies = response.data.results.data
                }
            })
        },
        getStaticid(id) {
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type", "getStaticOptions");
            post.append("auth", this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("lang", this.$cookies.get(this.$store.state.LangCooki));
            post.append("data[phrase]", id);
            // post.append("data[phrase]", "convertProducts");
            axios.post(this.$store.state.SAMCOTEC.r_path, post).then((response) => {
                // // console.log("i am here",response.data)
                if(id == 'convertProducts')
                    this.optionsS = response.data.results.data;
                else if(id == 'customerSource')
                    this.sources = response.data.results.data
                else if(id == 'inDustrial')
                    this.inDusts = response.data.results.data
                // // console.log("i am here",this.optionsS);
            });
        },
        getItemService() {
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type", "getItemService");
            post.append("auth", this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("lang", this.$cookies.get(this.$store.state.LangCooki));
            post.append("data[phrase]", 0);
            // post.append("data[phrase]", "convertProducts");
            axios.post(this.$store.state.SAMCOTEC.r_path, post).then((response) => {
                this.serviceList = response.data.results.data
            });
        },
    },
}
</script>
<style scoped>
.hideIcon {
    display:none;
}
</style>